import React from "react"
import clsx from "clsx"

import Button from "@material-ui/core/Button"
import { GradientBorder } from "../../GradientBorder"

import { getFormattedValue } from "../helpers/formatters"

import * as styles from "./Form.module.scss"
import { TooltipQuestion } from "../../MorBenefitsRedisgn/Tooltip/Tooltip"
import scrollToEl from "../../../helpers/scrolls"
import { DLClickEvent } from "../../../helpers/WatcherDL/DLEvents"

type FormProps = {
  willPayMonthly: number
  monthlySavings: number
}

const hintClassName = {
  xs: {
    left: -48,
    top: -124,
    width: 246,
    padding: "12px 24px 12px 16px",
  },
  sm: {
    left: 180,
  },
  md: {
    top: -133,
    left: -16,
  },
  lg: {
    left: 50,
  },
}

const tooltipHint =
  "Продолжительность рассрочки* — 24 месяца. В течение этого времени  использованные средства можно вернуть без переплаты"

const Form = ({ willPayMonthly, monthlySavings }: FormProps) => {
  const showSavings = monthlySavings > 0

  const buttonText = "Оформить карту"

  const handleClick = () => {
    DLClickEvent({ name: "click_cta", placement: "calculator" })
    scrollToEl("form")
  }

  return (
    <GradientBorder
      className={clsx(styles.form, styles.blockWithPayments, styles.formShadow, {
        [styles.noSavingsVal]: !showSavings,
      })}
    >
      <div className={styles.info}>
        <div className={clsx(styles.infoElem)}>
          <p className={styles.infoElemTitle}>Ежемесячный платёж</p>
          <p className={styles.value}>{`${getFormattedValue(willPayMonthly)} ₽`}</p>
        </div>
        <div
          className={clsx(styles.infoElem, {
            [styles.showSavingsVal]: showSavings,
            [styles.hideSavingsVal]: !showSavings,
          })}
        >
          {showSavings && (
            <>
              <p className={styles.infoElemTitle}>Выгода в месяц</p>
              <p className={clsx(styles.value)}>{`${getFormattedValue(monthlySavings)} ₽`}</p>
            </>
          )}
        </div>
        <div className={styles.infoElem}>
          <div className={styles.containerTitleTooltip}>
            <p className={styles.infoElemTitle}>Рассрочка*</p>
            <TooltipQuestion
              variantStyles="calcWithForm"
              anotherTooltipIcon
              smallCloseIcon
              text={tooltipHint}
              hintClassName={hintClassName}
              textBeforeTooltip="Рассрочка*"
            />
          </div>
          <p className={styles.value}>Без процентов</p>
        </div>
        <Button className={clsx(styles.btn)} type="button" onClick={handleClick}>
          {buttonText}
        </Button>
      </div>
    </GradientBorder>
  )
}

export default Form
